<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <Alert :message="requestError" type="alert-danger" v-if="requestError" />
    <div class="row">
      <div class="col-md-12 content_margin_bottom">
        <div class="card">
          <div class="card-body">
            <div>
              <label for="search">Enter Certified Users</label>
              <b-input-group key="" size="md" class="mb-3">
                <b-form-input
                  placeholder="Eg. Installer, plumber, enginner etc."
                  v-model="cert"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    text="Button"
                    @click="eSearch"
                    variant="success"
                    >Search</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </div>
            <div v-if="certificates.length <= 0">
              <h2>{{ userTitle }}</h2>
            </div>
            <div class="row mt-4" v-if="certificates.length > 0">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0" v-if="certificates.length > 0">
              <b-table
                :items="certificates"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sorrt-desc.sync="sortDesc"
                :fit-by.sync="sortBy"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                hover
              >
                <template v-slot:cell(action)="row">
                  <div class="dropdown d-flex">
                    <b-button
                      class="btn-success "
                      @click="sendRequest(row.item.id)"
                    >
                      Hire
                    </b-button>
                    <router-link
                      :to="`/user/${userId}/technician-details/${row.item.id}`"
                      class="btn btn-primary ml-1"
                    >
                      Details
                    </router-link>
                    <!-- </div> -->
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row" v-if="certificates.length > 0">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/views/layouts/main.vue";
import PageHeader from "@/components/page-header";
import Alert from "@/components/Alert.vue";
import appConfig from "@/app.config";
import store from "@/state/store";

export default {
  page: {
    title: "Hire",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Alert,
    PageHeader,
    Layout,
  },
  data() {
    return {
      // data table meta
      userId: this.$route.params.id,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "course",
      sortDesc: false,
      fields: [
        { key: "id", sortable: true, label: "ID" },
        { key: "full_name", sortable: true, label: "Full Name" },
        { key: "username", sortable: true, label: "Email" },
        { key: "phone", sortable: true, label: "Contact" },
        { key: "Action" },
      ],
      //end of table meta
      loading: false,
      id: null,
      requestError: null,
      success: null,
      error: null,
      key: null,
      title: "Hire",
      items: [
        {
          text: "User",
        },
        {
          text: "Hire",
          active: true,
        },
      ],
      certificates: [],
      certPDF: null,
      cert: "",
      userTitle: "",
    };
  },
  methods: {
    eSearch() {
      store
        .dispatch("enroll/eCertSearch", this.cert)
        .then((response) => {
          let certs = response.data.result;
          console.log(response);
          const users = certs.map((user) => {
            return {
              full_name: `${user.first_name} ${user.other_names} ${user.last_name}`,
              username: user.email,
              phone: user.phone,
              id: user.id,
            };
          });
          this.certificates = users;
          if (this.certificates.length == 0) {
            this.userTitle = "Technician Not Found!";
          }
        })
        .catch(() => {
          this.loading = false;
          this.success = false;
        });
    },
    sendRequest(enrollmentId) {
      const data = {
        recruiter_id: this.userId,
        technician_id: enrollmentId,
      };

      store
        .dispatch("hiring/getHire", data)
        .then((response) => {
          this.toast({ message: response.data.msg, type: "success" });
          this.eSearch();
        })
        .catch(() => {
          this.loading = false;
          this.success = false;
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  computed: {
    rows() {
      return this.certificates && this.certificates.length;
    },
  },
  created() {
    this.totalRows = this.certificates.length;
  },
};
</script>
<style scoped>
th {
  text-transform: uppercase;
}
</style>
